import { DatePicker, Flex, Form, TimePicker } from "antd"
import { endDateValidate, endTimeValidate, startDateValidate, startTimeValidate } from "pagesV2/pro/Calendar/utils"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"
import { Text } from "ui/Typography"
import dayjs from "dayjs"

const DateRange = () => {
  const { t } = useTranslation()
  return (
    <Flex vertical gap={spacings.M}>
      <Text fw={500}>{t("calendar.schedule_time_off.select_start_and_end_dates")}</Text>
      <Flex vertical>
        <Flex gap={spacings.M}>
          <Form.Item
            name="dateRangeFromDate"
            className="w-full"
            rules={[
              { required: true, message: t("calendar.schedule_time_off.start_date_is_required") },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  return startDateValidate(t, getFieldValue("dateRangeToDate"), value)
                }
              })
            ]}
          >
            <DatePicker
              className="w-full"
              format="MM/DD/YYYY"
              placeholder="MM/DD/YYYY"
              disabledDate={(current) => current?.isBefore(dayjs()?.startOf("day"))}
            />
          </Form.Item>
          <Form.Item
            name="dateRangeFromTime"
            className="w-full"
            rules={[
              { required: true, message: t("calendar.schedule_time_off.start_time_is_required") },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const endDate = getFieldValue("dateRangeToDate")
                  const startDate = getFieldValue("dateRangeFromDate")
                  if (endDate?.isAfter?.(startDate)) {
                    return Promise.resolve()
                  }
                  return startTimeValidate(t, getFieldValue("dateRangeToTime"), value)
                }
              })
            ]}
          >
            <TimePicker use12Hours format="hh:mm a" needConfirm={false} className="w-full" placeholder="HH:MM:SS" />
          </Form.Item>
        </Flex>
        <Flex gap={spacings.M}>
          <Form.Item
            name="dateRangeToDate"
            className="w-full"
            rules={[
              { required: true, message: t("calendar.schedule_time_off.end_date_is_required") },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  return endDateValidate(t, getFieldValue("dateRangeFromDate"), value)
                }
              })
            ]}
          >
            <DatePicker
              className="w-full"
              format="MM/DD/YYYY"
              placeholder="MM/DD/YYYY"
              disabledDate={(current) => current?.isBefore(dayjs()?.startOf("day"))}
            />
          </Form.Item>
          <Form.Item
            name="dateRangeToTime"
            className="w-full"
            rules={[
              { required: true, message: t("calendar.schedule_time_off.end_time_is_required") },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const endDate = getFieldValue("dateRangeToDate")
                  const startDate = getFieldValue("dateRangeFromDate")
                  if (endDate?.isAfter?.(startDate)) {
                    return Promise.resolve()
                  }
                  return endTimeValidate(t, getFieldValue("dateRangeFromTime"), value)
                }
              })
            ]}
          >
            <TimePicker use12Hours format="hh:mm a" needConfirm={false} className="w-full" placeholder="HH:MM:SS" />
          </Form.Item>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default DateRange
